import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';

const DeleteFolderOptionsDialog = ({
  onDelete,
  isOpen,
  setIsOpen,
}: {
  onDelete: (deleteConversations: boolean) => void;
  isOpen: boolean;
  setIsOpen: (newValue: boolean) => void;
}) => {
  const handleDelete = (deleteConversations: boolean) => {
    onDelete(deleteConversations);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete this item?
        </DialogTitle>
        <DialogContent>This will delete the folder for all collaborators.</DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleDelete(true)} color="primary" autoFocus>
            Delete All Conversations
          </Button>
          <Button
            onClick={() => {
              handleDelete(false);
            }}
            color="primary"
            autoFocus
          >
            Move Conversations to Another Folder
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteFolderOptionsDialog;
